import { Record } from 'immutable';
import formatMessageWrapper from '~/utils/format-message-wrapper/format-message-wrapper';

const keys: Fields = {
  value: '',
  translationKey: undefined,
  label: undefined,
};

interface Fields {
  value: string;
  translationKey?: string;
  label?: string;
}

export default class FilterDefinitionValueRecord extends Record<Fields>(keys) {
  getValue(): string {
    return this.value;
  }

  getTranslationKey(): string {
    return this.translationKey || '';
  }

  getLabel(): string {
    return this.label || '';
  }

  getFormattedLabel(): string {
    if (this.label) {
      return this.label;
    }

    return formatMessageWrapper(this.getTranslationKey());
  }

  getFormattedValue(): string {
    const translationKey = this.getTranslationKey();
    if (translationKey) {
      return formatMessageWrapper(translationKey);
    }
    return this.value;
  }
}
